import Tabs from '@mui/material/Tabs';
import { Suspense } from 'react'
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { useEffect } from 'react';
import { titlesArea, useEnabledMenuLevels, useMenuLevels, useMenuRepository, useSelectedMenuIndex } from '../atoms/menu';
import TailSpinLoader from '../components/TailSpinLoader';
import { Fab, FormControlLabel, InputBase, Paper, Switch } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useActivityFilter } from '../atoms/filtri';
import { grey } from '@mui/material/colors';
// import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { serviceEditMode } from '../atoms/serviceDescriptor';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { useIsAdmin } from '../atoms';
// import logConstants from '../utils/logConstants';

const aapTabProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

export const DoActivityAreaPage = () => {
    const navigate = useNavigate()
    const { area, level } = useParams()
    const { menuLevelsDef, menuLevelsDic } = useMenuLevels()
    const menu = useEnabledMenuLevels(`do/${area}`)
    const [menuIndex, setMenuIndex] = useSelectedMenuIndex()
    const menuRepo = useMenuRepository(area ?? '')
    const [serviceMode, setServiceMode] = useRecoilState(serviceEditMode)
    const { t } = useTranslation()
    const isAdmin = useIsAdmin()

    useEffect(() => {
        // console.log(`%cLevel: ${level}, menuIndex: ${menuIndex}`, logConstants.red10ptBold)
        if (!level) {
            // Find first applicable level compatible with menuIndex
            const alreadyExists = menu.find(m => m.index === menuIndex)
            const primo = alreadyExists ? alreadyExists : menu[0]
            // console.log(`Will navigate: ${primo?.path}`, primo)
            setMenuIndex(primo.index)
            navigate(primo.path)
        } else {
            const ml = menuLevelsDic[level]
            // console.log(`%cNot null Level: ${level}, menuIndex: ${menuIndex}, ml: ${ml.label}`, logConstants.red10ptBold)
            if (menuRepo && ml && menuRepo[ml.label]) {
                const mi = menuLevelsDic[level]?.index ?? 0
                // console.log(`Stay here: ${mi}`)
                setMenuIndex(mi)
            } else {
                const index = menu.findIndex(m => m.label === (Object.entries(menuRepo!))[0][0])
                // console.log(`%cWrong index: ${Object.entries(menuRepo!)[0][1].livello}`, logConstants.red10ptBold)
                setMenuIndex(menu[index].index)
                navigate(menu[index].path)
            }
        }
    }, [level, menu, menuIndex, menuLevelsDic, menuRepo, navigate, setMenuIndex])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        navigate(menuLevelsDef[newValue].pathext)
    }

    const handleMode = (newmode: 'read' | 'edit') => {
        setServiceMode(newmode)
        if(newmode === 'read' && area === 'azienda') {
            navigate("/")
        }
    }

    // console.log(`%cDoActivityAreaPage.render: level: ${level}, serviceMode: ${serviceMode}, index: ${level && menuLevelsDic[level].label}, Livelli: ${menu.filter(m => menuRepo![m.label]).map(m => m.label).join(';')}`, logConstants.green10ptBold)
    // console.log(`%cDoActivityAreaPage.menuRepo: ${menuRepo && Object.entries(menuRepo).map(x => x[0]).join(';')} esiste: ${!!(menuRepo && level && Object.entries(menuRepo).find(x => x[0] === menuLevelsDic[level].label))}`, logConstants.blue10ptBold)
    if (!level) return null
    return (
        <>
            <ActivityHeader area={area} level={level} />
            <ActivityFilter />
            <Box sx={{overflowY: 'auto'}}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mx: 1 }}>
                    {menu && menuRepo && Object.entries(menuRepo).find(x => x[0] === menuLevelsDic[level].label) && 
                        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <Box>
                                <Tabs value={menuLevelsDic[level].index} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                                    {menu.filter(m => menuRepo![m.label]).map(m => <Tab value={m.index} key={m.index} label={m.label} {...aapTabProps(m.index)} />)}
                                </Tabs>
                            </Box>
                            {isAdmin && 
                                <Box sx={{alignSelf: 'stretch', display: 'flex', m: 1}}>
                                    {serviceMode === 'read' && <Fab color='primary' size='small' sx={{zIndex: 300}} 
                                        onClick={(event) => handleMode('edit')} title={t('Modalità modifica')}><EditIcon /></Fab>}
                                    {serviceMode === 'edit' && <Fab color='primary' size='small' sx={{zIndex: 300}}
                                        onClick={(event) => handleMode('read')} title={t('Disabilita modalità modifica')}><VisibilityIcon /></Fab>}
                                </Box>
                            }
                        </Box>
                    }
                </Box>
                <Suspense fallback={(<TailSpinLoader position='relative' height={32} width={32} left={32} top={32} justifyContent='flex-start' />)}>
                    <Outlet />
                </Suspense>
            </Box>
        </>
    )
}

type ActivityHeaderPropsType = {
    area?: string,
    level?: string,
}
const ActivityHeader: React.FC<ActivityHeaderPropsType> = ({ area, level }) => {
    const { menuLevelsDic } = useMenuLevels()
    const areaTitle = area && titlesArea[area]
    const levelTitle = level && menuLevelsDic[level].label

    return (
        <Paper sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', bgcolor: (theme) => theme.palette.secondary.main /*grey[300]*/ }}>
            <Typography sx={{ fontSize: '18pt', mx: 2, color: '#EDEFF0' }}>{areaTitle}</Typography>
            <Typography sx={{ fontSize: '18pt', mx: 2, color: '#EDEFF0' }}>{levelTitle}</Typography>
        </Paper>
    )
}

type ActivityFilterPropsType = {
    placeholer?: string,
}
const ActivityFilter: React.FC<ActivityFilterPropsType> = ({ placeholer }) => {
    const [af, setAf] = useActivityFilter()
    const plh = placeholer || 'Filtro applicazioni...'
    const handleFilter = (ev: React.ChangeEvent<HTMLInputElement>) => setAf(c => ({ ...c, filter: ev.target.value }))
    const handleChange = (ev: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setAf(c => ({ ...c, authorizedOnly: checked }))
    const clearFilter = () => {
        setAf(c => ({ ...c, filter: '' }))
    }
    const {t} = useTranslation()
    const label: string = t('Solo autorizzate')

    return (
        <Suspense fallback={(<TailSpinLoader />)}>
            <Box sx={{ alignSelf: 'stretch', m: 1, display: 'flex', gap: 2 }}>
                <Paper component="form" sx={{ padding: '0px 4px', display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                    <InputBase sx={{ ml: 1, flex: 1 }} placeholder={plh} value={af.filter} onChange={handleFilter} />
                    {af.filter && <ClearIcon sx={{ color: grey[400], cursor: 'pointer' }} onClick={clearFilter} />}
                </Paper>
                <FormControlLabel control={<Switch checked={af.authorizedOnly} onChange={handleChange} />} label={label} />
            </Box>
        </Suspense>
    )
}